import { useEffect, useState } from "react";

const POLL_INTERVAL_MS = 3000;
const GIVE_UP_AFTER_MS = 60000;

// The provider's webhook settles the payment, and it can land a few seconds
// after the buyer is redirected back.
export const usePaymentConfirmation = ({ active, isPaid, reload }) => {
  const [timedOut, setTimedOut] = useState(false);
  const polling = active && !isPaid && !timedOut;

  useEffect(() => {
    if (!polling) return undefined;
    const interval = setInterval(reload, POLL_INTERVAL_MS);
    const giveUp = setTimeout(() => setTimedOut(true), GIVE_UP_AFTER_MS);
    return () => {
      clearInterval(interval);
      clearTimeout(giveUp);
    };
  }, [polling, reload]);

  if (!active) return "idle";
  if (isPaid) return "confirmed";
  return timedOut ? "timed_out" : "confirming";
};
